import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

@customElement('cds-table-row-expanded')
export class TableRowExpandedElement extends LitElement {
  static styles = css`
    :host {
      box-sizing: border-box;
      display: flex;
      flex-grow: 1;
      line-height: var(--token-global-font-line-height-xxxs, 1rem); /* 16px */;
      overflow: hidden;
      padding: var(--token-global-spacing-s16, 16px) var(--token-global-spacing-s24, 24px)
    }
  `;

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cds-table-row-expanded': TableRowExpandedElement;
  }
}
